// Too much files to change
/* eslint-disable import/no-internal-modules */
import DragHandle from '../../../../preact-components/control/DragHandle'
import ButtonControl from '../../../../preact-components/button-control'
import IconExternal from '../../../../preact-components/assets/icon-external-link'

interface Props {
  title: string
  url: string
  onDelete: () => void
  isSortable?: boolean
}

const FeaturedTopic = ({ title, url, onDelete, isSortable = true }: Props) => (
  <div className='featured-topic__item'>
    <div className='featured-topic__info'>
      {isSortable && <DragHandle />}
      <p className='featured-topic__title'>{title}</p>
      <a href={url} target='_blank' rel='noreferrer' className='featured-topic__link'>
        <IconExternal height={16} width={16} />
      </a>
    </div>
    <ButtonControl title='Remove' variant='warning' onClick={onDelete} />
  </div>
)

export default FeaturedTopic
